// extracted by mini-css-extract-plugin
export default {"content":"ThreeSteps_content__Whmst","content_list":"ThreeSteps_content_list__YfKAQ","content_img":"ThreeSteps_content_img__YGBmz","content_item":"ThreeSteps_content_item__srbWR"};